import React,{useEffect,useRef,useState} from 'react';
import service from '../../../services/property-task-defaults.service';
import { serviceOptions } from './model';

export default function AssignmentControl({mode,onChange,rentalIds,taskType,category,templateId,properties=[]}) {
  const [preview,setPreview]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false);
  const request=useRef(0);
  const contextKey=JSON.stringify([mode,rentalIds,taskType,category,templateId]);
  useEffect(()=>{
    request.current+=1;setPreview(null);setError('');setBusy(false);
    return ()=>{request.current+=1;};
  },[contextKey]);
  const previewDefaults=async()=>{
    const current=++request.current;
    setBusy(true);setError('');
    try {
      const {data}=await service.resolve({rental_ids:rentalIds,task_type:taskType,category,checklist_template_id:templateId});
      if(current===request.current)setPreview(data);
    } catch(e){if(current===request.current)setError(e.response?.data?.error||'Unable to preview taskers.');}
    finally{if(current===request.current)setBusy(false);}
  };
  const taskers=new Map((preview?.taskers||[]).map(a=>[`${a.type}:${a.id}`,a.name]));
  const labels=new Map(serviceOptions(templateId?[{id:templateId,name:'Checklist'}]:[]).map(option=>[option.value,option.label]));
  return <div className="uk-width-1-1">
    <label className="uk-form-label" htmlFor="task-default-mode">Taskers</label>
    <div className="uk-form-controls">
      <div uk-form-custom="target: > * > span:first-child">
        <select id="task-default-mode" value={mode} onChange={e=>onChange(e.target.value)}>
          <option value="property_defaults">Use property defaults</option><option value="explicit">Choose taskers</option><option value="unassigned">Leave unassigned</option>
        </select>
        <button className="uk-button uk-button-default" type="button" tabIndex="-1" aria-hidden="true">
          <span className="select-value">{{property_defaults:'Use property defaults',explicit:'Choose taskers',unassigned:'Leave unassigned'}[mode]}</span>
          <span uk-icon="icon: chevron-down" className="hms-align-right" />
        </button>
      </div>
    </div>
    {mode==='property_defaults'&&<>
      <p className="uk-text-meta">Use the saved taskers for each property.</p>
      <button type="button" className="uk-button uk-button-default" style={{width:'auto'}} disabled={busy||!rentalIds?.length} onClick={previewDefaults}>{busy?'Loading…':'Preview taskers'}</button>
      {error&&<p role="alert" className="uk-text-danger">{error}</p>}
      {preview&&<div className="uk-margin-small-top" role="status"><ul>{preview.resolutions.map(r=><li key={r.rental_id}>
        {properties.find(property=>String(property.rental_id)===String(r.rental_id))?.pms_id || r.property_name || `Property #${r.rental_id}`}: {r.assignees.filter(a=>a.assignment_role!=='owner').map(a=>taskers.get(`${a.type}:${a.id}`)||`Tasker #${a.id}`).join(', ')||'Unassigned'}
        {r.source&&` (${labels.get(r.source.service_key)||'Property'} default)`}
        {r.warnings.map(w=><div key={w} className="uk-text-warning">{w}</div>)}
      </li>)}</ul><p className="uk-text-meta">Taskers are checked again when you save.</p></div>}
    </>}
    {mode==='unassigned'&&<p className="uk-text-meta">No taskers will be assigned. You can assign them later.</p>}
  </div>;
}
